module.exports = __webpack_public_path__ + "static/media/CarosBold.7d3a8e60.woff";